import { connect, ConnectedProps } from 'react-redux'
import { permissionCheck } from '../../../../../../../../../../baseComponents/PermissionChecker/function'
import { InputTableLayoutStepProps, InputTableURLsTable } from '../../../../../../../../../../baseComponents/TwinTable/InputTableLayout/types'
import { CustomRenderString } from '../../../../../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import ModalProductPackOrder from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderTable/TableComponents/ModalsOrderTable/ModalProductPackOrder'
import { ColumnOrderTableSchema, OrderData } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/types'
import OrderSellLayout from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderSellLayout'
import { ProductExtendedTyInputTableListing } from '../../../../../../../../../../specificComponents/Product/types'
import { TwinDictionary } from '../../../../../../../../../../utils/globals/dictionary'
import locations from '../../../../../../../../../../utils/globals/locations'
import withLoading from '../../../../../../../../../../utils/hoc/withLoading'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'
import { AllReduxPayloads } from '../../../../../../../../../../utils/reducers'
import { WorkingCenterPayload } from '../../../../../../../../../../utils/reducers/company/workingCenters'
import { getUserPermissions } from '../../../../../../../../../../utils/reducers/getters'
import { SpecificPriceRulesPayload } from '../../../../../../../../../../utils/reducers/products/specificPriceRules'
import SellInvoiceCreateStepITHeaderConnect from './SellInvoiceCreateStepITHeader'
import { SellInvoiceProductModelTypeExtended } from '@teinor/erp/types/company/order/sell/sellInvoice/sellInvoiceProduct'
import useSellInvoiceHeaderUrls from '../../../../../../../../../../utils/hooks/sells/orders/useSellInvoiceHeaderUrls'
import { sellInvoiceStatusInversed } from '@teinor/erp/types/company/order/sell/sellInvoice'
import SellInvoiceCreateStepHeaderDecider from './SellInvoiceCreateStepHeader'

type SellInvoiceCreateStepProps = InputTableLayoutStepProps & ReduxSellInvoiceCreateStep & {}

const SellInvoiceCreateStep: React.FC<SellInvoiceCreateStepProps> = ({ inputTableURLs, completeData, setCompleteData, getCompleteData, tableConfiguration, setTableConfiguration, userPermissions, headerChanges, specificPriceRules, workingCenters }) => {
    const { t } = useTwinTranslation()
    const orderHeaderURLs = useSellInvoiceHeaderUrls()
    const dictWarehouses = workingCenters?.[completeData?.header?.WorkingCenter?.id]?.dictWarehouses
    const statusColumn: ColumnOrderTableSchema<ProductExtendedTyInputTableListing & SellInvoiceProductModelTypeExtended> = []
    if (completeData?.header.WorkSheetId || completeData?.header?.relatedWorkSheets?.length) {
        statusColumn.push(
            {
                id: 'haveWorkSheetProductStatus',
                dataKey: 'haveWorkSheetProductStatus',
                label: '',
                simpleLabel: t('workSheetStatus', 'Estado hoja de trabajo'),
                component: 'OrderProductWorkSheetStatus',
                hideColumnByDefault: true,
                Order: completeData?.header || {}
            },
        )
    }
    const columns: ColumnOrderTableSchema<ProductExtendedTyInputTableListing & SellInvoiceProductModelTypeExtended> = [
        {
            id: 'nLine',
            dataKey: 'nLine',
            label: t('line', 'Línea'),
            width: 70,
            hideColumnByDefault: true
        },
        {
            id: 'url',
            dataKey: 'url',
            label: t('image', 'Imagen'),
            component: 'ITDisplayImage',
            width: 70
        },
        {
            id: 'code_bar',
            dataKey: 'code_bar',
            label: t('codeBarShort', 'Cod. de barras'),
            simpleLabel: t('codeBar', 'Código de barras'),
            component: 'OrderSearchProductInput',
            field: 'code_bar',
            typeOnChange: 'onChangeAdd',
            sortable: true,
            hideColumnByDefault: true,
            minWidth: 115
        },
        {
            id: 'reference',
            dataKey: 'reference',
            label: t('reference', 'Referencia'),
            component: 'OrderSearchProductInput',
            field: 'reference',
            typeOnChange: 'onChangeAdd',
            sortable: true,
            minWidth: 100,
            hideColumnByDefault: true,
            className: 'sell_invoice_reference_name'
        },
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
            component: 'OrderSearchProductInputName',
            field: 'name',
            typeOnChange: 'onChangeAdd',
            sortable: true,
            hideColumnByDefault: true,
            className: 'sell_invoice_reference_name'
        },
        {
            id: 'referenceAndName',
            dataKey: 'name',
            label: t('referenceName', 'Referencia y nombre'),
            component: 'OrderSearchProductInputReferenceAndName',
            field: 'referenceAndName',
            typeOnChange: 'onChangeAdd',
            sortable: true,
            minWidth: 180,
            className: 'sell_invoice_reference_name'
        },
        {
            id: 'packQuantity',
            dataKey: 'packQuantity',
            label: '',
            simpleLabel: t('changeUnit', 'Editar unidades'),
            component: 'OrderChangePackUnit',
            width: 35,
        },
        {
            id: 'editProduct',
            dataKey: 'ProductId',
            label: '',
            simpleLabel: t('buttonSeeProduct', 'Botón de ver producto'),
            component: 'OrderEditProduct',
            width: 35,
            havePermission: permissionCheck(getUserPermissions('product.profile.main'), 'read'),
        },
        {
            id: 'descriptionDocuments',
            dataKey: 'descriptionDocuments',
            label: t('description', 'Descripción'),
            customRender: (parameterValue) => <CustomRenderString value={parameterValue} />,
            hideColumnByDefault: true
        },
        {
            id: 'shortDescriptionDocuments',
            dataKey: 'shortDescriptionDocuments',
            label: t('shortDescriptionS', 'Desc. corta'),
            simpleLabel: t('shortDescription', 'Descripción corta'),
            customRender: (parameterValue) => <CustomRenderString value={parameterValue} />,
            hideColumnByDefault: true
        },
        {
            id: 'CopyProduct.name',
            dataKey: 'name',
            label: '',
            simpleLabel: t('editProductName', 'Editar nombre del producto'),
            component: 'ITEditableName',
            typeOnChange: 'onChangeFetch',
            width: 50,
        },
        {
            id: 'notes',
            dataKey: 'notes',
            label: t('notes', 'Notas'),
            component: 'ITEditableText',
            typeOnChange: 'onChangeFetch'
        },
        {
            id: 'SpecificPriceRuleId',
            dataKey: 'SpecificPriceRuleId',
            label: t('priceRule', 'Tarifa'),
            component: 'ITSelectSpecificPriceRule',
            typeOnChange: 'onChangeTotalsFetch',
            items: specificPriceRules?.dictionary || {},
            className: 'w-100',
            hideColumnByDefault: true,
        },
        {
            id: 'initialUnitPriceWithoutTax',
            dataKey: 'initialUnitPriceWithoutTax',
            simpleLabel: t('price', 'Precio'),
            label: () => <div className='text-right w-full mr-10'>{t('price', 'Precio')}</div>,
            component: 'ITDisplayInitialPriceBase',
            typeOnChange: 'onChangeTotalsFetch',
            width: 120,
            sortable: true,
            skipEdit: !permissionCheck(getUserPermissions('sellOther.updateSellTotalPrice'), 'read')
        },
        {
            id: 'manualPrice',
            dataKey: 'manualPrice',
            label: t('syncPriceS', 'Sinc. P.'),
            simpleLabel: t('syncPrice', 'Sincronizar precio'),
            toolTip: t('ifChangedPricesyncPrice', 'Si has actualizado el precio manualmente, desde aquí podrás poner el precio original'),
            component: 'OrderSyncProductPrice',
            hideColumnByDefault: true,
            minWidth: 100,
        },
        {
            id: 'quantity',
            dataKey: 'quantity',
            label: t('quantity', 'Cantidad'),
            component: 'ITInputQuantity',
            typeOnChange: 'onChangeTotalsFetch',
            width: 100,
            readOnlyFnc: (allRowData) => !allRowData?.ProductId || allRowData?.SellDeliveryNoteProductId ? true : false
        },
        {
            id: 'quantity2',
            dataKey: 'quantity2',
            label: t('quantitySecondRes', 'Cant. sec.'),
            simpleLabel: t('quantitySecondary', 'Cantidad secundaria'),
            component: 'ITInputQuantity2',
            width: 100,
            typeOnChange: 'onChangeTotalsFetch',
            hideColumnByDefault: true,
            readOnlyFnc: (allRowData) => !allRowData?.ProductId || allRowData?.SellDeliveryNoteProductId ? true : false 
        },
        {
            id: 'wasteWeight',
            dataKey: 'wasteWeight',
            label: t('wasteWeight', 'Merma'),
            component: 'ITInputPercentage',
            typeOnChange: 'onChangeTotalsFetch',
            width: 100,
            hideColumnByDefault: true,
            allowEmpty: true,
            readOnlyFnc: (allRowData) => !allRowData?.ProductId || allRowData?.SellDeliveryNoteProductId ? true : false 
        },
        {
            id: 'calculatedQuantity',
            dataKey: 'calculatedQuantity',
            label: t('quantityCalculatedS', 'Cant. calc.'),
            toolTip: t('quantityCalculated', 'Cantidad calculada'),
            simpleLabel: t('quantityCalculated', 'Cantidad calculada'),
            component: 'ITInputQuantity',
            width: 110,
            typeOnChange: 'onChangeTotalsFetch',
            sortable: true,
            hideColumnByDefault: true,
            readOnlyFnc: () => true
        },
        {
            id: 'OrderAccountId',
            dataKey: 'OrderAccountId',
            label: t('chapter', 'Capítulo'),
            component: 'ITInputSelectAccounts',
            accounts: completeData?.header?.OrderAccounts,
            typeOnChange: 'onChangeTotalsFetch',
            minWidth: 110,
            hideColumnByDefault: true
        },
        {
            id: 'discount',
            dataKey: 'discount',
            label: t('discount', 'Descuento'),
            component: 'ITInputDiscount',
            width: 135,
            typeOnChange: 'onChangeTotalsFetch'
        },
        {
            id: 'delivery_date',
            dataKey: 'delivery_date',
            label: t('deliveryEstimated', 'Entrega estimada'),
            component: 'ITInputCalendar',
            width: 160,
            typeOnChange: 'onChangeFetch',
            hideColumnByDefault: true
        },
        {
            id: 'rowPriceWithoutTaxAndTotalDiscount',
            dataKey: 'rowPriceWithoutTaxAndTotalDiscount',
            label: () => <div className='text-right w-full'>{t('priceTotal', 'Precio Total')}</div>,
            simpleLabel: t('priceTotal', 'Precio Total'),
            component: 'ITDisplayEditFinalPriceBase',
            typeOnChange: 'onChangeTotalsFetch',
            with_vat: false,
            width: 120,
            skipEdit: !permissionCheck(getUserPermissions('sellOther.updateSellTotalPrice'), 'read')
        },
        {
            id: 'rowPriceWithTaxAndTotalDiscount',
            dataKey: 'rowPriceWithTaxAndTotalDiscount',
            label: () => <div className='text-right w-full mr-10'>{t('totalPriceWithTaxShort', 'Precio Total Imp.')}</div>,
            simpleLabel: t('totalPriceWithTaxShort', 'Precio Total Imp.'),
            component: 'ITDisplayEditFinalPriceBase',
            typeOnChange: 'onChangeTotalsFetch',
            with_vat: true,
            width: 145,
            hideColumnByDefault: true,
            skipEdit: !permissionCheck(getUserPermissions('sellOther.updateSellTotalPrice'), 'read')
        },
        {
            id: 'totalWithTaxWithComplements',
            dataKey: 'totalWithTaxWithComplements',
            simpleLabel: t('totalWithComplementsAndVat', 'Total con complementos e imp.'),
            label: () => <div className='text-right w-full' >{t('withComplementsAndVatS', 'Con comp. e imp.')}</div>,
            component: 'ITDisplayPrice',
            width: 160,
            hideColumnByDefault: true,
            toolTip: t('totalWithComplementsAndVatL', 'Total con complementos e impuestos'),
        },
        {
            id: 'totalWithoutTaxWithComplements',
            dataKey: 'totalWithoutTaxWithComplements',
            simpleLabel: t('totalWithComplements', 'Total con complementos'),
            label: () => <div className='text-right w-full'> {t('withComplementsS', 'Con comp.')}</div>,
            component: 'ITDisplayPrice',
            width: 110,
            hideColumnByDefault: true,
            toolTip: t('totalWithComplements', 'Total con complementos')
        },
        {
            id: 'totalWithoutTaxWithComplementsPrev',
            dataKey: 'totalWithoutTaxWithComplementsPrev',
            simpleLabel: t('totalWithoutTaxWithComplementsPrev', 'Total con complementos antes de desc.'),
            label: () => <div className='text-right w-full'> {t('withComplementsS', 'Con comp.')}</div>,
            component: 'ITDisplayPrice',
            width: 110,
            hideColumnByDefault: true,
            toolTip: t('totalWithoutTaxWithComplementsPrev', 'Total con complementos antes de descuentos'),
        },
        {
            id: 'unitPriceWithComplements',
            dataKey: 'unitPriceWithComplements',
            simpleLabel: t('unitPriceWithComplements', 'Precio unitario con complementos'),
            label: () => <div className='text-right w-full'> {t('unitPricewithComplementsS', 'P. U. comp.')}</div>,
            component: 'ITDisplayPrice',
            width: 110,
            hideColumnByDefault: true,
            toolTip: t('unitPriceWithComplements', 'Precio unitario con complementos'),
        },
        {
            id: 'editAddonProduct',
            dataKey: 'ProductId',
            label: '',
            simpleLabel: t('buttonAddAddonProduct', 'Botón de añadir complemento'),
            component: 'OrderEditAddonProduct',
            width: 33,
            completeData: completeData,
        },
        {
            id: 'deleteRow',
            dataKey: 'ProductId',
            label: '',
            simpleLabel: t('deleteLine', 'Eliminar línea'),
            width: 33,
            component: 'ITDeleteRow',
            requiredColumn: true
        },
        {
            id: 'dragLine',
            dataKey: 'nLine',
            label: '',
            simpleLabel: t('moveLine', 'Mover línea'),
            width: 33,
            component: 'ITDragHandle',
            requiredColumn: true
        },
        {
            id: 'WarehouseId',
            dataKey: 'WarehouseId',
            label: t('warehouse', 'Almacén'),
            component: 'ITInputSelectWarehouses',
            minWidth: 110,
            hideColumnByDefault: true,
            items: dictWarehouses || [],
            value: completeData?.header?.WarehouseId,
            readOnlyFnc: (allRowData) => allRowData?.SellDeliveryNoteProductId ? true : false 
        },
        {
            id: 'unique_number',
            dataKey: 'unique_number',
            label: t('uniqueNumberShort', 'Nº único'),
            simpleLabel: t('uniqueNumber', 'Número único'),
            toolTip: t('uniqueNumber', 'Número único'),
            component: 'OrderUniqueNumberProduct',
            hideColumnByDefault: true,
            warehouses: dictWarehouses || {},
            readOnlyFnc: (allRowData) => allRowData?.SellDeliveryNoteProductId ? true : false 
        },
        {
            id: 'PrintTags',
            dataKey: 'ProductId',
            label: '',
            simpleLabel: t('printTags', 'Imprimir etiquetas'),
            width: 33,
            component: 'OrderPrintTags',
            hideColumnByDefault: true
        },
        ...statusColumn
    ]
    return (
        <OrderSellLayout modelId='SellInvoiceId' name='sellInvoiceCreateStep' translations={{ headerTitle: t('invoice', 'Factura') }} className='sellInvoiceTable' buttonSave={permissionCheck(getUserPermissions('sell.invoice'), 'update')
            ?
            <SellInvoiceCreateStepHeaderDecider completeData={completeData} onSubmit={getCompleteData} data={completeData as OrderData} urls={{ sellInvoice: '/api/app/order/sell/sellInvoice/updateSellInvoice', navigateUrl: locations.sellInvoiceSingle }} {...{ orderHeaderURLs, setCompleteData, updateHeaderData: inputTableURLs?.updateHeaderData, userPermissions }} />
            : undefined} InputTableHeaderChildren={SellInvoiceCreateStepITHeaderConnect} {...{ orderHeaderURLs, columns, inputTableURLs, completeData, setCompleteData, getCompleteData, setTableConfiguration, tableConfiguration, userPermissions, headerChanges, orderStatusDict: sellInvoiceStatusInversed}}>
            {completeData?.header?.errorsToResolve?.length
                ? <ErrorsToResolveModal {...completeData?.header?.errorsToResolve[0]} getData={getCompleteData} inputTableURLs={inputTableURLs} />
                : null
            }
        </OrderSellLayout>
    )
}

interface ErrorsToResolveModalProps {
    element: TwinDictionary
    errorToResolve: '__left_select_quantity'
    inputTableURLs: InputTableURLsTable
    getData: () => void
}

const ErrorsToResolveModal: React.FC<ErrorsToResolveModalProps> = ({ element, errorToResolve, ...rest }) => {
    const modalsByError = {
        '__left_select_quantity': ModalProductPackOrder
    }
    const Component = modalsByError[errorToResolve]
    return <Component element={element} {...rest} />
}

const sellInvoiceCreateStepDispatch = {
    setSpecificPriceRules: (payload: SpecificPriceRulesPayload) => ({ type: 'CHANGE_SPECIFICPRICERULES', payload }),
    setWorkingCenters: (payload: WorkingCenterPayload) => ({ type: 'CHANGE_WORKINGCENTER', payload }),
}

type ReduxSellInvoiceCreateStep = ConnectedProps<typeof sellInvoiceCreateStepConnect>
const mapSellInvoiceCreateStepConnector = (state: AllReduxPayloads) => ({ specificPriceRules: state.specificPriceRules, workingCenters: state.workingCenters})
const sellInvoiceCreateStepConnect = connect(mapSellInvoiceCreateStepConnector, sellInvoiceCreateStepDispatch)

const sellInvoiceCreateStepConnectLoading = withLoading(SellInvoiceCreateStep, [{ fetchUrl: '/api/app/product/specificPrice/getAllSpecificPriceRules', propName: 'specificPriceRules', setFunctionName: 'setSpecificPriceRules' }, { fetchUrl: '/api/app/workingCenter/getAllWorkingCentersComplete', propName: 'workingCenters', setFunctionName: 'setWorkingCenters' }])
const SellInvoiceCreateStepConnect = sellInvoiceCreateStepConnect(sellInvoiceCreateStepConnectLoading)

export default SellInvoiceCreateStepConnect